import { render } from "./ChannelSalesPage.vue?vue&type=template&id=21dee8f7"
import script from "./ChannelSalesPage.vue?vue&type=script&lang=js"
export * from "./ChannelSalesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__